import HeaderEmbed from '@common/HeaderEmbed'
import '@common/reset.css'
import './style.scss'
import { Activity, useEffect, useState } from 'react'
import Home from './components/Home'
import Noticia from './components/Noticia'
import { formatNumeric, netejaNumero } from '@common/utils'

export default function App({ lang, preview, embedHome }) {
	const [premis, setPremis] = useState(null)

	useEffect(() => {
		fetch(`${process.env.API_CLIENT}/embeds/v1/loteria-reis`)
			.then((res) => res.json())
			.then((json) => setPremis(json.data))
			.catch((error) => console.log(error))
	}, [])

	if (!premis) return null

	const taulesReis = [
		{
			title: 'PRIMER PREMI',
			key: 'primer_premi',
			blocks: [
				{ label: (premi) => formatNumeric(premi), prize: '2.000.000€' },
				{ label: (premi) => formatNumeric(netejaNumero(premi) - 1), prize: '12.000€' },
				{ label: (premi) => formatNumeric(netejaNumero(premi) + 1), prize: '12.000€' },
				{ label: (premi) => `Acabats en ${premi.substring(2)}`, prize: '1.000€' },
				{ label: (premi) => `Acabats en ${premi.substring(3)}`, prize: '1.000€' },
				{ label: (premi) => `Centenes amb valor ${premi.substring(0, 3)}`, prize: '1.000€' },
			],
		},
		{
			title: 'SEGON PREMI',
			key: 'segon_premi',
			blocks: [
				{ label: (premi) => formatNumeric(premi), prize: '750.000€' },
				{ label: (premi) => formatNumeric(netejaNumero(premi) - 1), prize: '6.100€' },
				{ label: (premi) => formatNumeric(netejaNumero(premi) + 1), prize: '6.100€' },
				{ label: (premi) => `Acabats en ${premi.substring(2)}`, prize: '1.000€' },
				{ label: (premi) => `Centenes amb valor ${premi.substring(0, 3)}`, prize: '1.000€' },
			],
		},
		{
			title: 'TERCER PREMI',
			key: 'tercer_premi',
			blocks: [
				{ label: (premi) => formatNumeric(premi), prize: '250.000€' },
				{ label: (premi) => `Centenes amb valor ${premi.substring(0, 3)}`, prize: '1.000€' },
			],
		},
	]

	if (!premis) return null
	return (
		<>
			<Activity mode={preview ? 'visible' : 'hidden'}>
				<HeaderEmbed allowHomeEmbed />
			</Activity>

			<Home premis={premis} embedHome={embedHome} />
			<Activity mode={embedHome ? 'hidden' : 'visible'}>
				<Noticia taulesReis={taulesReis} premis={premis} />
			</Activity>
		</>
	)
}
